import { makeStyles, tokens, Text } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';
import ConversionTab from '../components/management/ConversionTab';
import { pageShell } from '../components/layout/pageShell';

const useStyles = makeStyles({
  page: {
    ...pageShell,
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXS,
    paddingBottom: tokens.spacingVerticalM,
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
  },
  title: {
    fontSize: tokens.fontSizeHero800,
    fontWeight: tokens.fontWeightSemibold,
    lineHeight: '1.1',
    margin: 0,
  },
  subtitle: {
    color: tokens.colorNeutralForeground3,
    fontSize: tokens.fontSizeBase300,
  },
});

export default function ConversionPage() {
  const styles = useStyles();
  const { t } = useTranslation();

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <Text as="h1" className={styles.title}>
          {t('conversionPage.title')}
        </Text>
        <span className={styles.subtitle}>{t('conversionPage.subtitle')}</span>
      </div>

      <ConversionTab />
    </div>
  );
}
